"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

exports.styles = function (_a) {
  var fontSize = _a.fontSize,
      fontFamily = _a.fontFamily,
      sizeBorderRadius = _a.sizeBorderRadius,
      colorText = _a.colorText,
      colorBgSecondary = _a.colorBgSecondary,
      colorError = _a.colorError,
      colorSuccess = _a.colorSuccess,
      fontSize1 = _a.fontSize1,
      colorWarning = _a.colorRating;
  return {
    base: {
      fontFamily: fontFamily,
      fontSize: fontSize,
      display: 'inline-block',
      textAlign: 'center',
      padding: '4px 6px',
      borderRadius: sizeBorderRadius,
      whiteSpace: 'nowrap',
      fontWeight: 'bold',
      '& p': {
        fontSize: fontSize1.fontSize,
        marginTop: 'auto',
        marginBottom: 'auto',
        textTransform: 'uppercase',
        userSelect: 'none'
      }
    },
    default: {
      backgroundColor: colorBgSecondary.normal,
      '& p': {
        color: colorText.normal
      }
    },
    warning: {
      backgroundColor: 'rgba(255, 17, 0, 0.1)',
      '& p': {
        color: colorError.normal
      }
    },
    process: {
      backgroundColor: 'rgba(255, 158, 0, 0.1)',
      '& p': {
        color: colorWarning.normal
      }
    },
    done: {
      backgroundColor: 'rgba(40, 199, 93, 0.1)',
      '& p': {
        color: colorSuccess.normal
      }
    },
    empty: {
      border: '1px solid rgba(0, 0, 0, 0.12)',
      '& p': {
        color: 'rgba(153, 153, 153, 1)'
      }
    }
  };
};